import { render } from "./NewMapElementInfo.vue?vue&type=template&id=7c489d1e&scoped=true"
import script from "./NewMapElementInfo.vue?vue&type=script&lang=js"
export * from "./NewMapElementInfo.vue?vue&type=script&lang=js"

import "./NewMapElementInfo.vue?vue&type=style&index=0&id=7c489d1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c489d1e"]])

export default __exports__